var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BModal",
    { attrs: { active: "", "has-modal-card": "" }, on: { close: _vm.onClose } },
    [
      _c("div", { staticClass: "push-customer-searcher" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v("\n          Buscar cliente por email\n        ")
            ])
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c("SearcherByEmail", {
                on: {
                  select: function($event) {
                    return _vm.$router.push({ name: "NewInvoice" })
                  }
                }
              })
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c(
                "RouterLink",
                {
                  staticClass: "button",
                  attrs: { to: { name: "NewInvoice" } }
                },
                [_vm._v("\n          Cerrar\n        ")]
              )
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }